/**
 * @generated SignedSource<<87335d910025f5f3c353d6af38ecfbde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminDashboardQuery$variables = Record<PropertyKey, never>;
export type AdminDashboardQuery$data = {
  readonly adminDashboardInfo: {
    readonly db: {
      readonly dbSize: number;
      readonly numBlocks: number;
      readonly numEvents: number;
      readonly numEventsListed: number;
      readonly numEventsPendingDeletion: number;
      readonly numEventsPendingSync: number;
      readonly numKnownGroups: number;
      readonly numKnownUsers: number;
      readonly numPlaylists: number;
      readonly numPlaylistsListed: number;
      readonly numRealms: number;
      readonly numSeries: number;
      readonly numSeriesListed: number;
      readonly numSeriesPendingDeletion: number;
      readonly numSeriesPendingSync: number;
      readonly numUserRealms: number;
      readonly numUserSessions: number;
    };
    readonly problems: {
      readonly realmsBrokenBlocks: ReadonlyArray<string>;
      readonly realmsBrokenName: ReadonlyArray<string>;
    };
    readonly searchIndex: {
      readonly isHealthy: boolean;
      readonly meili: {
        readonly eventIndex: {
          readonly isIndexing: boolean;
          readonly numDocuments: number;
        } | null | undefined;
        readonly lastUpdate: string | null | undefined;
        readonly playlistIndex: {
          readonly isIndexing: boolean;
          readonly numDocuments: number;
        } | null | undefined;
        readonly realmIndex: {
          readonly isIndexing: boolean;
          readonly numDocuments: number;
        } | null | undefined;
        readonly seriesIndex: {
          readonly isIndexing: boolean;
          readonly numDocuments: number;
        } | null | undefined;
        readonly size: number;
        readonly userIndex: {
          readonly isIndexing: boolean;
          readonly numDocuments: number;
        } | null | undefined;
        readonly version: string;
      } | null | undefined;
      readonly queueLen: number;
      readonly queuedEvents: number;
      readonly queuedPlaylists: number;
      readonly queuedRealms: number;
      readonly queuedSeries: number;
      readonly queuedUsers: number;
      readonly state: string | null | undefined;
    };
    readonly sync: {
      readonly externalApiVersion: string | null | undefined;
      readonly harvestedUntil: string;
      readonly lastUpdatedItem: string;
      readonly ocReachable: boolean;
      readonly requiredTobiraApiVersion: string;
      readonly tobiraApiVersion: string | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UserData">;
};
export type AdminDashboardQuery = {
  response: AdminDashboardQuery$data;
  variables: AdminDashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numDocuments",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isIndexing",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "AdminInfo",
  "kind": "LinkedField",
  "name": "adminDashboardInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminDbInfo",
      "kind": "LinkedField",
      "name": "db",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numEvents",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numEventsPendingSync",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numEventsPendingDeletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numEventsListed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSeries",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSeriesPendingSync",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSeriesPendingDeletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSeriesListed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numPlaylists",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numPlaylistsListed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numRealms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numUserRealms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numBlocks",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numKnownUsers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numKnownGroups",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numUserSessions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dbSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminSearchIndexInfo",
      "kind": "LinkedField",
      "name": "searchIndex",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHealthy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AdminMeiliInfo",
          "kind": "LinkedField",
          "name": "meili",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "size",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastUpdate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AdminSingleSearchIndexInfo",
              "kind": "LinkedField",
              "name": "eventIndex",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AdminSingleSearchIndexInfo",
              "kind": "LinkedField",
              "name": "seriesIndex",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AdminSingleSearchIndexInfo",
              "kind": "LinkedField",
              "name": "playlistIndex",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AdminSingleSearchIndexInfo",
              "kind": "LinkedField",
              "name": "realmIndex",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AdminSingleSearchIndexInfo",
              "kind": "LinkedField",
              "name": "userIndex",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "queueLen",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "queuedEvents",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "queuedSeries",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "queuedPlaylists",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "queuedRealms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "queuedUsers",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminSyncInfo",
      "kind": "LinkedField",
      "name": "sync",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ocReachable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestedUntil",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastUpdatedItem",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredTobiraApiVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tobiraApiVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalApiVersion",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminProblemInfo",
      "kind": "LinkedField",
      "name": "problems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "realmsBrokenName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "realmsBrokenBlocks",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminDashboardQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserData"
      },
      (v1/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AdminDashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRealmHandle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseStudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseEditor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateUserRealm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateSeries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTobiraAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canFindUnlisted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRole",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v1/*: any*/)
    ]
  },
  "params": {
    "cacheID": "b4098d6c88b4c9d2ce4baab2ce85dffc",
    "id": null,
    "metadata": {},
    "name": "AdminDashboardQuery",
    "operationKind": "query",
    "text": "query AdminDashboardQuery {\n  ...UserData\n  adminDashboardInfo {\n    db {\n      numEvents\n      numEventsPendingSync\n      numEventsPendingDeletion\n      numEventsListed\n      numSeries\n      numSeriesPendingSync\n      numSeriesPendingDeletion\n      numSeriesListed\n      numPlaylists\n      numPlaylistsListed\n      numRealms\n      numUserRealms\n      numBlocks\n      numKnownUsers\n      numKnownGroups\n      numUserSessions\n      dbSize\n    }\n    searchIndex {\n      isHealthy\n      state\n      meili {\n        version\n        size\n        lastUpdate\n        eventIndex {\n          numDocuments\n          isIndexing\n        }\n        seriesIndex {\n          numDocuments\n          isIndexing\n        }\n        playlistIndex {\n          numDocuments\n          isIndexing\n        }\n        realmIndex {\n          numDocuments\n          isIndexing\n        }\n        userIndex {\n          numDocuments\n          isIndexing\n        }\n      }\n      queueLen\n      queuedEvents\n      queuedSeries\n      queuedPlaylists\n      queuedRealms\n      queuedUsers\n    }\n    sync {\n      ocReachable\n      harvestedUntil\n      lastUpdatedItem\n      requiredTobiraApiVersion\n      tobiraApiVersion\n      externalApiVersion\n    }\n    problems {\n      realmsBrokenName\n      realmsBrokenBlocks\n    }\n  }\n}\n\nfragment UserData on Query {\n  currentUser {\n    username\n    displayName\n    userRealmHandle\n    canUpload\n    canUseStudio\n    canUseEditor\n    canCreateUserRealm\n    canCreateSeries\n    isTobiraAdmin\n    canFindUnlisted\n    roles\n    userRole\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b80e3c15e9453b1f75c97a59c12b977";

export default node;
